var _rect, _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArRuler = function SvgArRuler(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1112_5309",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 110,
    height: 110
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    rx: 10,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1112_5309)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 89.7959,
    r: 15.7143,
    transform: "rotate(-180 55 89.7959)",
    fill: "#FFE8C1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.3776,
    cy: 45.4592,
    r: 6.17347,
    transform: "rotate(-180 81.3776 45.4592)",
    fill: "#E2D5F5",
    fillOpacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M103.617 65.6814L92.5842 54.6479C91.5572 53.6208 89.8913 53.6208 88.8644 54.6478L87.9629 55.549L92.4881 60.074C92.9963 60.5823 92.9963 61.4067 92.4882 61.9148C91.98 62.4229 91.1555 62.423 90.6473 61.9148L86.1224 57.3897L83.0545 60.4575L85.1255 62.5284C85.6334 63.0364 85.6335 63.861 85.1255 64.369C84.6174 64.8772 83.7927 64.8771 83.2848 64.369L81.2139 62.2982L78.146 65.366L80.217 67.4369C80.725 67.9449 80.725 68.7696 80.217 69.2776C79.7089 69.7857 78.8842 69.7856 78.3764 69.2776L76.3054 67.2067L73.2376 70.2745L77.7627 74.7996C78.2708 75.3078 78.2708 76.1322 77.7627 76.6403C77.2546 77.1484 76.4301 77.1484 75.922 76.6402L71.3969 72.1151L68.329 75.1831L70.4 77.2539C70.9079 77.7618 70.9079 78.5864 70.3998 79.0946C69.8919 79.6026 69.0673 79.6025 68.5593 79.0945L66.4885 77.0236L63.4207 80.0914L65.4915 82.1623C65.9995 82.6703 65.9995 83.4949 65.4915 84.003C64.9834 84.5111 64.1587 84.511 63.6507 84.0031L61.58 81.9322L58.5121 85L63.0371 89.5251C63.5453 90.0333 63.5453 90.8577 63.0372 91.3658C62.5292 91.8738 61.7046 91.8739 61.1964 91.3657L56.6714 86.8407L55.7703 87.7418C54.7432 88.7689 54.7433 90.4346 55.7703 91.4616L66.8037 102.495C67.8307 103.522 69.4965 103.522 70.5235 102.495L103.618 69.4008C104.645 68.374 104.644 66.7083 103.617 65.6814Z",
    fill: "url(#paint0_linear_1112_5309)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1112_5309",
    x1: 104.388,
    y1: 53.8776,
    x2: 55,
    y2: 53.8776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArRuler);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ar-ruler.a41f220a3685b162e050c5296bf03397.svg";